import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import { A as AppTooltip } from './index-3fb48509.esm.js';
import React__default, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppText, a as AppIcon } from './index-6b88191c.esm.js';

const AppLabelCountIcon = _ref => {
  let {
    onPress,
    label,
    labelStyle,
    icon,
    height = 24,
    width = 24,
    borderRadius = 5,
    backgroundColor,
    count,
    isEmoji,
    countLabelStyle,
    isDescriptionVisible = true,
    fontSize = 8,
    countLabelRightOffset = 15,
    countLabelTopOffset = 2,
    countColor,
    descriptionLabelStyle,
    labelCountIconViewStyle,
    descriptionLabelColor,
    wrapperCountLabelStyle,
    isDisabled,
    activeColor,
    startingOpacity = 0.9,
    disabledOpacity = 0.6,
    color,
    tooltip,
    popableViewStyle,
    minWidth = 10,
    wrapperWidth,
    marginRight = 0,
    marginLeft = 0,
    shouldShowOne = true,
    descriptionLabelWrapperStyle,
    borderWrapperRadius,
    paddingWrapper,
    ...props
  } = _ref;
  const [isMouseHover, setIsMouseHover] = useState(false);
  const {
    currentTheme,
    mode
  } = useTheme();
  const _styles = styleGenerator(currentTheme, fontSize, countLabelTopOffset, countLabelRightOffset);
  const coreView = /*#__PURE__*/React__default.createElement("div", {
    "data-tip": label,
    "data-for": label,
    style: {
      width: wrapperWidth || "fit-content",
      alignItems: "center",
      minWidth: "".concat(width, "px"),
      marginRight: "".concat(marginRight, "px"),
      display: "flex",
      flexDirection: "column",
      cursor: !isDisabled && "pointer",
      marginLeft: "".concat(marginLeft, "px"),
      backgroundColor: backgroundColor,
      opacity: isDisabled ? disabledOpacity : isMouseHover ? 1 : startingOpacity,
      borderRadius: borderWrapperRadius,
      padding: paddingWrapper
    }
    //@ts-ignore
    ,
    onMouseEnter: () => setIsMouseHover(true),
    onMouseLeave: () => setIsMouseHover(false),
    onMouseDown: e => onPress(label, e)
  }, count > (shouldShowOne ? 0 : 1) && /*#__PURE__*/React__default.createElement(AppText, {
    color: isMouseHover && activeColor ? activeColor : countColor,
    style: [_styles.countLabel, countLabelStyle],
    wrapperStyle: [_styles.wrapperCountLabel, wrapperCountLabelStyle]
  }, count === null || count === void 0 ? void 0 : count.toString()), /*#__PURE__*/React__default.createElement(AppIcon, _extends({}, props, {
    wrapperStyle: {
      width: "fit-content"
    },
    labelStyle: labelStyle,
    style: {
      height: height,
      width: width,
      borderRadius: borderRadius
    },
    key: label,
    label: isEmoji && icon,
    icon: !isEmoji && icon,
    color: !isDisabled && isMouseHover ? activeColor : color
  })), isDescriptionVisible && /*#__PURE__*/React__default.createElement(AppText
  //@ts-ignore
  , {
    numberOfLines: 1,
    style: [_styles.descriptionStyle, descriptionLabelStyle],
    wrapperStyle: descriptionLabelWrapperStyle,
    color: descriptionLabelColor
  }, label));
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, tooltip && /*#__PURE__*/React__default.createElement(AppTooltip, {
    offsetBottom: -5,
    id: label,
    place: "bottom",
    type: mode,
    effect: "solid",
    getContent: () => tooltip
  }), coreView);
};
const styleGenerator = (props, fontSize, countLabelTopOffset, countLabelRightOffset) => {
  return StyleSheet.create({
    countLabel: {},
    countLabelStyle: {
      fontSize: fontSize,
      fontWeight: "bold"
    },
    labelCountIconView: {
      width: "fit-content",
      alignItems: "center",
      marginRight: 5,
      minWidth: 30
    },
    descriptionStyle: {
      marginTop: 3,
      fontSize: fontSize,
      maxWidth: 40,
      overflow: "hidden"
    },
    wrapperCountLabel: {
      alignSelf: "flex-end",
      fontSize: fontSize,
      position: "absolute",
      right: -countLabelRightOffset,
      top: -countLabelTopOffset
    }
  });
};
AppLabelCountIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppLabelCountIcon",
  "props": {
    "height": {
      "defaultValue": {
        "value": "24",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Height of the icon/emoji"
    },
    "width": {
      "defaultValue": {
        "value": "24",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Width of the icon/emoji"
    },
    "borderRadius": {
      "defaultValue": {
        "value": "5",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Border radius of the view surronding the icon/emoji"
    },
    "isDescriptionVisible": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the component shows the label prop uner the icon"
    },
    "fontSize": {
      "defaultValue": {
        "value": "8",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Font size of the label used for the count"
    },
    "countLabelRightOffset": {
      "defaultValue": {
        "value": "15",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Offset to the right of count label to the icon"
    },
    "countLabelTopOffset": {
      "defaultValue": {
        "value": "2",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Offset to the top of count label to the icon"
    },
    "startingOpacity": {
      "defaultValue": {
        "value": "0.9",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "disabledOpacity": {
      "defaultValue": {
        "value": "0.6",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "minWidth": {
      "defaultValue": {
        "value": "10",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "marginRight": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "marginLeft": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "shouldShowOne": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "Sets up whether 1 should be shown or not"
    },
    "onPress": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(label: string, e: any) => void",
        "signature": {
          "arguments": [{
            "name": "label",
            "type": {
              "name": "string"
            }
          }, {
            "name": "e",
            "type": {
              "name": "any"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Event triggered when the icon is pressed"
    },
    "label": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Description placed next to the icon"
    },
    "descriptionLabelColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Color of the description"
    },
    "labelStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style of label used for the description"
    },
    "icon": {
      "required": true,
      "tsType": {
        "name": "any"
      },
      "description": "Icon/Emoji passed to display"
    },
    "backgroundColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Background color of the view surronding the icon/emoji"
    },
    "count": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Number representing the count to be displayed"
    },
    "isEmoji": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the component expects icon to be an emoji"
    },
    "isDisabled": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "countLabelStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style of label used for the count"
    },
    "countColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Colour applied to the count label"
    },
    "descriptionLabelStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style of label used for the description"
    },
    "labelCountIconViewStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style of the wrapper of all sub-components"
    },
    "wrapperCountLabelStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style of the label used to show the count"
    },
    "descriptionLabelWrapperStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "popableViewStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style of the wrapper of all sub-components"
    },
    "activeColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "color": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "tooltip": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "borderWrapperRadius": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "wrapperWidth": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "paddingWrapper": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    }
  }
};

export { AppLabelCountIcon as A };
